import { render } from "./NewCustomerEdit.vue?vue&type=template&id=8a8a7d88&ts=true"
import script from "./NewCustomerEdit.vue?vue&type=script&lang=ts"
export * from "./NewCustomerEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__